
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/users/create",
      function () {
        return require("private-next-pages/users/create.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/users/create"])
      });
    }
  